module.exports = __webpack_public_path__ + "static/media/WordMark_jpg.7bf9c618.jpg";